module.exports = __webpack_public_path__ + "static/img/result_celling.f9c4c77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_celling.jpg
// module id = IXwL
// module chunks = 3